module.exports = __webpack_public_path__ + "static/media/cardIconPending.c03ee6bf.svg";